import type { Header } from '@tanstack/react-table';
import { SortDirection } from '@common/enums';

export function getSortDirection<T>(header: Header<T, unknown>): SortDirection | undefined {
    return header.column.getIsSorted() === 'asc'
        ? SortDirection.ascending
        : header.column.getIsSorted() === 'desc'
          ? SortDirection.descending
          : undefined;
}
